module.exports = __webpack_public_path__ + "static/media/Win.ec405864.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/Win.png
// module id = 193
// module chunks = 0